import React from "react";

const RightButton = (props) => {
  return (
    <button className="w-32 text-xl rounded mx-1  border-4 border-x-blue-500 border-y-blue-500  py-3  hover:bg-slate-100 lg:w-28 lg:text-lg">
      {props.tags}
    </button>
  );
};

export default RightButton;
// mx-1 my-4 lg:my-0